import React, { Component, createRef } from "react";
import { InputGroup, Input, Button } from "reactstrap";

class ChatInput extends Component {
  constructor(props) {
    super(props);
    this.state = { text: "" };
    this.inputRef = createRef();
  }

  focus = () => {
    if (this.inputRef.current) this.inputRef.current.focus();
  };

  handleChange = (e) => {
    this.setState({ text: e.target.value });
    if (this.props.onTyping) this.props.onTyping();
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { text } = this.state;
    if (text.trim()) {
      this.props.onSend(text.trim());
      this.setState({ text: "" });
    }
  };

  handleKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      this.handleSubmit(e);
    }
  };

  render() {
    const { isLoading } = this.props;
    const { text } = this.state;

    return (
      <form onSubmit={this.handleSubmit}>
        <InputGroup>
          <Input
            innerRef={this.inputRef}
            type="textarea"
            value={text}
            onChange={this.handleChange}
            onKeyPress={this.handleKeyPress}
            placeholder="Hỏi về doanh thu, tồn kho, khách hàng..."
            rows={1}
            style={{
              resize: "none",
              borderRadius: "20px 0 0 20px",
              paddingLeft: 16,
            }}
          />
          <Button
            color="primary"
            type="submit"
            disabled={!text.trim()}
            style={{ borderRadius: "0 20px 20px 0", minWidth: 60 }}
          >
            {isLoading ? (
              <span
                className="spinner-border spinner-border-sm"
                role="status"
              />
            ) : (
              <i className="simple-icon-paper-plane" />
            )}
          </Button>
        </InputGroup>
      </form>
    );
  }
}

export default ChatInput;
